import { render, staticRenderFns } from "./RejectPurchase.vue?vue&type=template&id=72ae3729&"
import script from "./RejectPurchase.vue?vue&type=script&lang=js&"
export * from "./RejectPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports